// Dependencies
import React from 'react';
import { Link } from 'gatsby';
import PropTypes from 'prop-types';
import uuid from 'react-uuid';

// Components
import Container from '../../container/container';
import Image from '../../image/image';

// Styles
import CallToActionBannerStyles from './callToActionBanner.styles';

export default function CallToActionBanner({ layout }) {
  const bgImg = layout?.backgroundImage;

  const heading = layout?.heading;
  const text = layout?.text;
  const buttons = layout?.buttons;

  return (
    <CallToActionBannerStyles>
      {bgImg && <Image image={bgImg} backgroundColor="sand" background />}

      <Container>
        <div className="box">
          {heading && <h2 className="heading">{heading}</h2>}
          <p className="text">{text}</p>
          {buttons && (
            <div className="btn-group">
              {buttons.map((button) => (
                <Link
                  key={uuid()}
                  to={button?.button?.url}
                  className="btn dark"
                >
                  {button?.button?.title}
                </Link>
              ))}
            </div>
          )}
        </div>
      </Container>
    </CallToActionBannerStyles>
  );
}

CallToActionBanner.propTypes = {
  layout: PropTypes.shape({
    backgroundImage: PropTypes.shape({
      altText: PropTypes.string,
      gatsbyImage: PropTypes.shape({}),
    }),
    heading: PropTypes.string,
    text: PropTypes.string,
    buttons: PropTypes.arrayOf(PropTypes.shape({})),
  }),
};

CallToActionBanner.defaultProps = {
  layout: {},
};
